module.exports = __webpack_public_path__ + "img/dw.c710d29d.gif";